"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var Box_1 = __importDefault(require("@mui/material/Box"));
var react_redux_1 = require("react-redux");
var react_redux_firebase_1 = require("react-redux-firebase");
var react_router_1 = require("react-router");
var react_router_dom_1 = require("react-router-dom");
var NavTabs_1 = __importDefault(require("atomicComponents/atoms/NavTabs/NavTabs"));
var LoadingContent_1 = __importDefault(require("components/Spinners/LoadingContent"));
var HudledHelmet_1 = __importDefault(require("containers/App/HudledHelmet"));
var HoCs_1 = require("utils/HoCs");
var hooks_1 = require("./hooks");
var ReportBenchmark_1 = __importDefault(require("./Report/ReportBenchmark"));
var ReportMissedOpportunities_1 = __importDefault(require("./Report/ReportMissedOpportunities"));
var ReportOverview_1 = __importDefault(require("./Report/ReportOverview"));
var ReportSavings_1 = __importDefault(require("./Report/ReportSavings"));
var SaaSAnalysed_1 = __importDefault(require("./SaaSAnalysed"));
var selectors_1 = require("./selectors");
var SaaSAudit = function (_a) {
    var company = _a.company;
    var saasAuditTabs = [
        { label: 'Report', href: '/saas-audit/report' },
        { label: 'SaaS Analysed', href: '/saas-audit/saas-analysed' },
        { label: 'Savings', href: '/saas-audit/savings' },
        // { label: 'Missed Opportunities', href: '/saas-audit/missed-opportunities' },
        { label: 'Benchmark', href: '/saas-audit/benchmark' },
    ];
    (0, hooks_1.useGetAuditData)(company.id);
    var lastAudit = (0, react_redux_1.useSelector)(selectors_1.selectLatestAudit);
    if (!(0, react_redux_firebase_1.isLoaded)(lastAudit)) {
        return (0, jsx_runtime_1.jsx)(LoadingContent_1.default, {});
    }
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(HudledHelmet_1.default, { title: "SaaS Audit", description: "SaaS Audit" }), (0, jsx_runtime_1.jsxs)(Box_1.default, __assign({ display: "flex", flexDirection: "column", overflow: "auto", height: "100%" }, { children: [(0, jsx_runtime_1.jsx)(NavTabs_1.default, { tabs: saasAuditTabs }), (0, jsx_runtime_1.jsxs)(react_router_dom_1.Switch, { children: [(0, jsx_runtime_1.jsx)(react_router_1.Route, { exact: true, path: "/saas-audit/benchmark", component: ReportBenchmark_1.default }), (0, jsx_runtime_1.jsx)(react_router_1.Route, { exact: true, path: "/saas-audit/report", component: ReportOverview_1.default }), (0, jsx_runtime_1.jsx)(react_router_1.Route, { exact: true, path: "/saas-audit/savings", component: ReportSavings_1.default }), (0, jsx_runtime_1.jsx)(react_router_1.Route, { exact: true, path: "/saas-audit/missed-opportunities", component: ReportMissedOpportunities_1.default }), (0, jsx_runtime_1.jsx)(react_router_1.Route, { exact: true, path: "/saas-audit/saas-analysed", component: SaaSAnalysed_1.default }), (0, jsx_runtime_1.jsx)(react_router_dom_1.Redirect, { exact: true, path: "/saas-audit", to: "/saas-audit/report" })] })] }))] }));
};
exports.default = (0, HoCs_1.HasCompanyHoC)(SaaSAudit);
